import {
  CreatePlanRequest,
  CreatePlanResponse,
} from '../../types/plans/types';
import { getCustomerIdFromToken } from '../../utils/getCustomerIdFromToken';
import { analytics } from '../../utils/analytics';
import { post } from '../apiService';
import { invalidatePlansListCache } from './listPlans';

export const createPlan = async (
  body?: CreatePlanRequest,
): Promise<{
  data: CreatePlanResponse;
  loading: boolean;
}> => {
  const customer = getCustomerIdFromToken();
  if (!customer) {
    throw new Error('Customer Id is not available');
  }
  if (!body) {
    throw new Error('Body is not available');
  }
  const url = `/resourceMatrix/insurance/create?customerId=${customer}`;
  let loading = true;
  try {
    const responseData = await post(
      url,
      body as Record<string, unknown>,
      {
        headers: {
          'Content-Type': 'application/json',
        },
      },
    );
    invalidatePlansListCache();
    loading = false;
    analytics.trackEvent('create', 'plan');
    return { data: responseData as CreatePlanResponse, loading };
  } catch (error) {
    loading = false;
    throw new Error('Failed to create insurance plan');
  }
};
